import {
  CoreAutocomplete,
  CoreAutocompleteProps,
} from '../internal/WixUiCoreComponents/components/CoreAutocomplete';
import { TPAComponentProps } from '../../types';
import { DropdownTheme } from '../Dropdown/types';

export interface TPAAutocompleteProps extends TPAComponentProps {
  /** the error message to display */
  errorMessage?: string;
  /** apply error state*/
  error?: boolean;
  theme?: DropdownTheme;
}

export type AutocompleteProps = TPAAutocompleteProps &
  CoreAutocompleteProps &
  TPAComponentProps;

export type AutocompleteType = React.FunctionComponent<AutocompleteProps> & {
  createOption: typeof CoreAutocomplete.createOption;
  createDivider: typeof CoreAutocomplete.createDivider;
};
